import React, { useCallback, useMemo } from 'react';
import { Table, Typography } from 'antd';
import './discriptionSection.css';

const { Text } = Typography;

const DiscriptionSection = (props) => {
  const { input = '' } = props;
  // Function to parse the input string
  const parseContent = useCallback((input) => {
    const [description, tableData] = input?.split('\n\n|');
    const tableLines = `|${tableData}`.split('\n')?.filter((line) => line?.trim() !== '');

    // Parse Table Header
    const headers = tableLines?.[0]
      ?.split('|')
      ?.map((header) => header?.trim())
      ?.filter(Boolean);

    // Parse Table Rows
    const rows = tableLines?.slice(2)?.map((row) =>
      row
        ?.split('|')
        ?.map((cell) => cell?.trim())
        ?.filter(Boolean)
    );

    return {
      description,
      headers,
      rows,
    };
  }, []);

  // Function to render text with words inside backticks as bold
  const renderBoldText = useCallback((text) => {
    const parts = text?.split(/`(.*?)`/g); // Split by backticks
    return parts?.map((part, index) =>
      index % 2 === 1 ? (
        <b key={index} style={{ color: '#1890ff' }}>
          {part}
        </b>
      ) : (
        part
      )
    );
  }, []);

  const renderDescription = useCallback(
    (text) => {
      return text?.split('\n').map((line, index) => (
        <Text key={index}>
          {renderBoldText(line)}
          <br />
        </Text>
      ));
    },
    [renderBoldText]
  );

  const { description, headers, rows } = useMemo(() => parseContent(input), [input]);

  const columns = useMemo(
    () =>
      headers.map((header, columnIndex) => ({
        title: renderBoldText(header), // Render header text with bolding
        dataIndex: `col${columnIndex}`,
        key: `col${columnIndex}`,
        render: (text) => <>{renderBoldText(text)}</>, // Render cell text with bolding
      })),
    [headers, renderBoldText]
  );

  const dataSource = useMemo(
    () =>
      rows.map((row, rowIndex) => {
        const dataRow = {};
        row.forEach((cell, columnIndex) => {
          dataRow[`col${columnIndex}`] = cell;
        });
        return { ...dataRow, key: rowIndex };
      }),
    [rows]
  );

  return (
    <div className="dynamic-content-renderer">
      <div className="description">{renderDescription(description)}</div>
      {rows && rows.length ? <Table columns={columns} dataSource={dataSource} pagination={false} bordered /> : ''}
    </div>
  );
};

export default DiscriptionSection;
